export * from './about/About';
export * from './masonryGallery/MasonryGallery';
export * from './gallery/Gallery';



// WEBPACK FOOTER //
// ./src/components/index.js